module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./pt-BR.coffee"));
	}, "locale/pt-BR");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=locale/[name]!./app/locale/pt-BR.coffee
// module id = 293
// module chunks = 97